import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BPApi } from '../services/api';
import { useLanguage } from '../contexts/LanguageContext';

interface CreatePatientProps {
  onLogin: (patientId: string) => void;
  api: BPApi;
}

export function CreatePatient({ onLogin, api }: CreatePatientProps) {
  const [patientId, setPatientId] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Only allow numbers
    if (value === '' || /^\d+$/.test(value)) {
      setPatientId(value);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!patientId.trim()) {
      setError(t('create.error.required'));
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      await api.createPatient(patientId);
      onLogin(patientId);
    } catch (error) {
      setError(t('create.error.failed'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card">
        <h1 className="title">{t('app.title')}</h1>
        <h2 className="subtitle">{t('create.title')}</h2>
        
        <form onSubmit={handleSubmit} className="form">
          <div className="input-group">
            <input
              id="patientId"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              className="input"
              value={patientId}
              onChange={handleChange}
              placeholder={t('create.placeholder')}
            />
          </div>

          {error && <div className="error">{error}</div>}

          <button type="submit" className="button button-primary" disabled={isLoading}>
            {isLoading ? t('create.loading') : t('create.button')}
          </button>

          <div className="separator">{t('create.or')}</div>

          <button
            type="button"
            className="button button-outline"
            onClick={() => navigate('/')}
          >
            {t('create.back')}
          </button>
        </form>
      </div>
    </div>
  );
} 